export const WEB_GAMES_UPLOADS_FOLDER = 'webgames';
export const LEGACY_WEB_GAMES_UPLOADS_FOLDER = 'webgames-generated';

function filesPublicBaseUrlFromEnv(): string {
    const raw = process.env.REACT_APP_FILES_PUBLIC_BASE_URL || '';
    if (!raw) return '';
    return raw.replace(/\/$/, '');
}

function apiOriginFromEnv(): string {
    const raw = process.env.REACT_APP_API_URL || '';
    if (!raw) return '';
    try {
        return new URL(raw).origin;
    } catch {
        return '';
    }
}

export function isWebGameUploadsApiPath(pathOrUrl: string | null | undefined): boolean {
    if (pathOrUrl == null) return false;
    const normalized = pathOrUrl.trim();
    return normalized.includes('uploads_api/');
}

export function normalizeWebGameUploadCollectionStoredPath(pathOrUrl: string | null | undefined): string {
    if (pathOrUrl == null) return '';
    const trimmed = pathOrUrl.trim();
    if (!trimmed) return '';
    return isWebGameUploadsApiPath(trimmed) ? normalizeWebGameUploadStoredPath(trimmed) : trimmed;
}

export function normalizeWebGameCoverImageStoredPath(pathOrUrl: string | null | undefined): string {
    if (pathOrUrl == null) return '';
    const trimmed = pathOrUrl.trim();
    if (!trimmed) return '';
    if (!isWebGameUploadsApiPath(trimmed)) {
        return trimmed;
    }
    if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
        return trimmed;
    }
    const resolved = resolveWebGameUploadsPublicUrl(trimmed);
    if (resolved) {
        return resolved;
    }
    return normalizeWebGameUploadStoredPath(trimmed);
}

export function normalizeWebGameUploadStoredPath(pathOrUrl: string | null | undefined): string {
    if (pathOrUrl == null) return '';
    const normalized = pathOrUrl.trim();
    if (!normalized) return '';

    if (normalized.startsWith('http://') || normalized.startsWith('https://')) {
        try {
            const parsed = new URL(normalized);
            const pathname = parsed.pathname.replace(/^\/files(?=\/)/, '');
            const uploadsIndex = pathname.indexOf('/uploads_api/');
            if (uploadsIndex >= 0) {
                return pathname.slice(uploadsIndex + 1);
            }
            const legacyIndex = pathname.indexOf('uploads_api/');
            if (legacyIndex >= 0) {
                return pathname.slice(legacyIndex);
            }
        } catch {
            return normalized;
        }
        return normalized;
    }

    return normalized.startsWith('/') ? normalized.slice(1) : normalized;
}

export function resolveWebGameUploadsPublicUrl(
    pathOrUrl: string | null | undefined,
    options?: { apiOrigin?: string; filesPublicBaseUrl?: string }
): string {
    if (pathOrUrl == null) return '';
    const normalized = pathOrUrl.trim();
    if (!normalized) return '';
    if (normalized.startsWith('http://') || normalized.startsWith('https://')) {
        return normalized;
    }

    const storedPath = normalizeWebGameUploadStoredPath(normalized);
    const uploadsPath = storedPath.startsWith('uploads_api/')
        ? `/${storedPath}`
        : storedPath.startsWith('/uploads_api/')
            ? storedPath
            : null;
    if (!uploadsPath) return '';

    const filesBase = (options?.filesPublicBaseUrl ?? filesPublicBaseUrlFromEnv()).replace(/\/$/, '');
    if (filesBase) {
        return `${filesBase}${uploadsPath}`;
    }

    const apiOrigin = (options?.apiOrigin ?? apiOriginFromEnv()).replace(/\/$/, '');
    if (apiOrigin) {
        return `${apiOrigin}${uploadsPath}`;
    }
    return '';
}
